<ng-container *ngIf="data$ | async as data">
  <cx-generic-link
    [class]="'social-btn'"
    [url]="data.locUrl ?? ''"
    [target]="'_blank'"
    [title]="data.title ?? ''"
    [ariaLabel]="data.title ?? ''"
  >
    <img class="icon {{ data.socialNetwork }}" alt="" />
  </cx-generic-link>
</ng-container>
